import { Card, CardBody, Col} from "reactstrap";
import { ActiveList } from "../../../../utils/Constant";
import { activeData, activeListData } from "../../../../Data/Ui-Kits/Lists/Lists";
import { LI, UL } from "../../../../AbstractElements";
import CardHeaderCommon from "../../../../CommonElements/CardHeaderCommon/CardHeaderCommon";

const ActiveLists = () => {
  return (
    <Col xl="4" md="6">
      <Card className='custom-list-group active-list-custom'>
        <CardHeaderCommon title={ActiveList} span={activeData} headClass='card-no-border' />
        <CardBody>
          <UL>
            <LI className="active bg-warning-light">
              <i className="icofont icofont-arrow-right"></i>UI Kits
            </LI>
            {activeListData.map((item, index) => (
              <LI key={index}>
                <i className="icofont icofont-arrow-right"></i>
                {item}
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ActiveLists;
